import React, { Fragment, useState, useEffect, memo } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback, Container } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import DataReactTable from './DataReactTable';
import SearchModalMedicines from '../../../../SearchModals/Medicines/SearchModalMedicines';
import ReactTableActionsFormula from './ReactTableActionsFormula';
import CustomTableMedicalOrders from './CustomTableMedicalOrders';
import { useRef } from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { faVial, faStethoscope, faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProceduresModal from './modalsQuickServices/ProceduresModal';
import LabsModal from './modalsQuickServices/LabsModal';
import ConsulationModal from './modalsQuickServices/ConsulationModal';

const Header = ({ column }) => (
    <span className="react-table__column-header">
        <span>
            {column}
        </span>
    </span>
);

const MedicalOrdersFunctionalCom = ({
    ailments,
    id_historia,
    id_admision,
    MedicalOrders,
    loadMedicalOrders,
    handlerCUPS,
    handlerDiagnosticName,
    searchDiagnostic,
    selectDiagnostic,
    searchMedicalOrders,
    searchMedicaments,
    addDiagnostic,
    removeDiagnostic,
    addObservation,
    handlerMedicalOrderTime,
    handlerFormulasNew,
    removeFormula,
    handlerObservationAndProcedureTextMedicalOrder,
    handlerMedicalObservationTextMedicalOrder,
    isCloseClinicHistory,
    formulasFromPharmacological,
    removeFormulaByIndex,
    onEditFormulaFromMedicalOrders
}) => {
    const [proceduresList, setProceduresList] = useState([]);
    const [consultList, setConsultList] = useState([]);
    const [labList, setLabList] = useState([]);
    const [principioactivo, setPrincipioactivo] = useState('');
    const [cantidad, setCantidad] = useState('');
    const [formafarmaceutica, setFormafarmaceutica] = useState('');
    const [viaadministracion, setViaadministracion] = useState('');
    const [dosis, setDosis] = useState('');
    const [frequence, setFrequence] = useState('');
    const [frequenceVal, setFrequenceVal] = useState(0)
    const [duration, setDuration] = useState(0);
    const [cantidadMedicamentes, setCantidadMedicamentes] = useState(0);
    const [formulas, setFormulas] = useState([]);
    const [medicines, setMedicines] = useState([])
    const [openMedicines, setOpenMedicines] = useState(false);
    const [medicine, setMedicine] = useState([]);
    const [dataToTableFormula, setDataToTableFormula] = useState([]);
    const [prescriptionPharmacologial, setPrescriptionPharmacologial] = useState([]);
    const [onEdit, setOnEdit] = useState(false);
    const [indexToUpdate, setIndexToUpdate] = useState(null);
    const [otherFrequency, setOtherFrequency] = useState('');

    //Consultas - Procedimientos - Laboratorios

    const [modalProcedures, setModalProcedures] = useState(false);
    const [modalConsult, setModalConsult] = useState(false);
    const [modalLabs, setModalLabs] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [loadAddedDiagnostics, setLoadAddedDiagnostics] = useState(false);

    useEffect(() => {
        const loadCups = () => {
            let proced = [], consul = [], labs = [];
            fetch(process.env.REACT_APP_PUBLIC_URL + 'servicio-acceso-rapido/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    for (let obj of data) {
                        obj.tipo === 1 ? labs.push(obj) :
                            obj.tipo === 2 ? consul.push(obj) :
                                proced.push(obj)
                    }
                    //console.log(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

            setProceduresList(proced);
            setConsultList(consul);
            setLabList(labs);

        }

        loadCups();

        //loadMedicalOrdersLocal();

        /* if (!!formulasFromPharmacological) {
            console.log('formulasFromPharmacological', formulasFromPharmacological)
            if (!!formulasFromPharmacological.length) {
                console.log('2formulasFromPharmacological', formulasFromPharmacological.length);

                let oldFormulas = dataToTableFormula;
                let newFormulas = [...oldFormulas, ...formulasFromPharmacological]
                const uniqueFormulas = [];

                const unique = newFormulas.filter(element => {
                    const isDuplicate = uniqueFormulas.find(formu => formu.principioactivo === element.principioactivo);

                    if (!isDuplicate) {
                        uniqueFormulas.push(element);
                        return true;
                    }

                    return false;
                });
                setDataToTableFormula(unique);
                console.log('1erUseEffect', newFormulas)
            }
        } */

    }, []);

    useEffect(() => {
        refreshStateFromProps();
        //console.log(refTable);
    }, [MedicalOrders]);

    useEffect(() => { 
        if(!!dosis && !!frequence && !!duration) {
            handlerFrequence(frequence);
        }

    },[dosis, frequence, duration])

    /*    useEffect(() => {
           if (!!prescriptionPharmacologial) {
               console.log("WIDTUSEEFFECT", prescriptionPharmacologial)
               if (!!prescriptionPharmacologial.length) {
                   prescriptionPharmacologial.forEach(form => handlerFormulasNew(form));
               }
           }
       }, [prescriptionPharmacologial]) */


    const refreshStateFromProps = () => {
        let formulasToAdd = MedicalOrders.formulas;
        let oldFormulas = dataToTableFormula;
        let mixedFormulas = [...formulasToAdd, ...oldFormulas]
        const uniqueFormulas = [];
        const unique = mixedFormulas.filter(element => {
            const isDuplicate = uniqueFormulas.find(formu => formu.activePrinciple === element.activePrinciple);
            if (!isDuplicate) {
                uniqueFormulas.push(element);
                return true;
            }
            return false;
        });
        setDataToTableFormula(unique);
    }


    const handlerFrequence = (freq) => {
        let durationToMonth = parseInt(duration / 7);
        let oneMonth = parseInt(Math.ceil(duration / 30));
        let twoMonth = parseInt(Math.ceil(duration / 60));
        let threeMonth = parseInt(Math.ceil(duration / 90));
        let sixMonth = parseInt(Math.ceil(duration / 180));
        let everyTwoWeek = parseInt(Math.ceil(duration / 14));        

        switch (freq) {
            case "Una vez al día":
                calculateUnits(dosis, 1, duration);
                break;
            case "Dos veces al día":
                calculateUnits(dosis, 2, duration);
                break;
            case "Tres veces al día":
                calculateUnits(dosis, 3, duration);
                break;
            case "Cuatro veces al día":
                calculateUnits(dosis, 4, duration);
                break;
          /*   case "Cada 4 horas":
                calculateUnits(dosis, 6, duration);
                break;
            case "Cada 8 horas":
                calculateUnits(dosis, 3, duration);
                break; */
            case "Una vez a la semana":
                calculateUnits(dosis, 1, durationToMonth);
                break;
            case "Dos veces a la semana":
                calculateUnits(dosis, 2, durationToMonth);
                break;
            case "Cada 15 dias":
                calculateUnits(dosis, 1, everyTwoWeek);
                break;    
            case "Una vez al mes":
                calculateUnits(dosis, 1, oneMonth);
                break;
            case "Una cada dos meses":
                calculateUnits(dosis, 1, twoMonth);
                break;
            case "Una cada tres meses":                
                calculateUnits(dosis, 1, threeMonth);    
                break;
            case "Una cada seis meses":
                calculateUnits(dosis, 1, sixMonth);
                break;
            case "Dosis unica":
                calculateUnits(1, 1, 1);
                break;
            case "Según necesidad":
                calculateUnits(dosis, 1, duration);
                break;
            default:
                calculateUnits(dosis, 1, duration);
                break;
        }

    };

    const calculateUnits = (dosisCa, frequenceValCa, durationCa) => {
        if (!!dosisCa && !!frequenceValCa && !!durationCa) {
            let valor = (parseInt(dosisCa) * frequenceValCa) * parseInt(durationCa);
            setCantidadMedicamentes(valor)
        }
    }

    const frecuencyLetters = (freq) => {

        switch (freq) {
            case "Dos veces al día":
                return 2
            case "Tres veces al día":
                return 3
            case "Cuatro veces al día":
                return 4
            case "Cada 4 horas":
                return 6;
            case "Cada 8 horas":
                return 3;
            case "Dos veces a la semana":
                return 2;
            default:
                return 1
        }

    };

    const handlerDuration = (dur) => {
        setDuration(dur);        
    }

    const durationTable = (dur, dos, freq) => {
        let valor = (dos * freq) * dur;
        return valor;
    }

    const onUpdateFormula = (indexForm, formulaToUpdate) => {
        if (!!formulaToUpdate) {
            setOnEdit(true);
            setIndexToUpdate(indexForm);
            setPrincipioactivo(formulaToUpdate.activePrinciple);
            setDosis(formulaToUpdate.dose);
            setDuration(formulaToUpdate.duration);
            setFrequence(formulaToUpdate.frequency);
            setFrequenceVal(parseInt(frecuencyLetters(formulaToUpdate.frequency)));
            setViaadministracion(formulaToUpdate.route);
            setCantidad(formulaToUpdate.concentration);
            setFormafarmaceutica(formulaToUpdate.pharmaceuticalForm);
            setCantidadMedicamentes((parseInt(formulaToUpdate.dose) * parseInt(frecuencyLetters(formulaToUpdate.frequency) * parseInt(formulaToUpdate.duration))));
            setOtherFrequency(formulaToUpdate.otherFrequency ?? '');
        }
    }

    const onUpdateFormulaFromTable = () => {
        if (principioactivo === '' || dosis === 0 || duration === 0 || frequence === "") {
            alert("Ingresa todos los datos de la formula");
            //this.setState({ modalOpen: true });
        } else {
            let formula = {
                activePrinciple: principioactivo,
                concentration: cantidad,
                pharmaceuticalForm: formafarmaceutica,
                route: viaadministracion,
                dose: dosis,
                frequency: frequence,
                duration: duration,
                units: cantidadMedicamentes,
                otherFrequency: otherFrequency ?? ''
            };
            if (indexToUpdate !== null) {
                onEditFormulaFromMedicalOrders(indexToUpdate, formula);
                setMedicine([])
                setOnEdit(false);
                setPrincipioactivo('');
                setDosis('');
                setDuration('');
                setCantidadMedicamentes('');
                setFrequence('');
                setViaadministracion('');
                setCantidad('');
                setFormafarmaceutica('');
                setOtherFrequency('');
            }

        }
    }

    const createFormula = () => {
        if (!!medicine.length) {
            if (medicine.length === 0 || dosis === 0 || duration === 0 || frequence === "") {
                alert("Ingresa todos los datos de la formula");
                //this.setState({ modalOpen: true });
            } else {
                let formula = {
                    activePrinciple: medicine.principioactivo,
                    concentration: medicine.cantidad + ' ' + medicine.unidadreferencia,
                    pharmaceuticalForm: medicine.formafarmaceutica,
                    route: medicine.viaadministracion,
                    dose: dosis,
                    frequency: frequence,
                    duration: duration,
                    units: cantidadMedicamentes,
                    otherFrequency: otherFrequency ?? ''
                    
                };
                handlerFormulasNew(formula);

                setMedicine([])
                setPrincipioactivo('');
                setDosis('');
                setDuration('');
                setCantidadMedicamentes('');
                setFrequence('');
                setViaadministracion('');
                setCantidad('');
                setFormafarmaceutica('');
                setOtherFrequency('');
            }
        } else {
            if (principioactivo === '' || dosis === 0 || duration === 0 || frequence === "") {
                alert("Ingresa todos los datos de la formula");
                //this.setState({ modalOpen: true });
            } else {
                let formula = {
                    activePrinciple: principioactivo,
                    concentration: cantidad,
                    pharmaceuticalForm: formafarmaceutica,
                    route: viaadministracion,
                    dose: dosis,
                    frequency: frequence,
                    duration: duration,
                    units: cantidadMedicamentes,
                    otherFrequency: otherFrequency ?? ''
                };
                handlerFormulasNew(formula);

                setMedicine([])
                setPrincipioactivo('');
                setDosis('');
                setDuration('');
                setCantidadMedicamentes('');
                setFrequence('');
                setViaadministracion('');
                setCantidad('');
                setFormafarmaceutica('');
                setOtherFrequency('');
            }
        }
    }


    const loadMedicalOrdersLocal = () => {
        var data = {
            id_historia: id_historia,
            id_admision: 0,
        };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'antecedente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.existe) {
                        let pharmacologicBackgroud = data.contenido[0].farmacologicos != null ? data.contenido[0].farmacologicos.farmacologicos[0].farmacologico.table : null;

                        console.log('farmaTable', pharmacologicBackgroud)
                        let comp = pharmacologicBackgroud.map(med => {
                            let formula = {
                                activePrinciple: med.principioactivo,
                                concentration: med.concentracion,
                                pharmaceuticalForm: '',
                                route: med.viaadministracion,
                                dose: med.dosis,
                                frequency: med.frecuencia,
                                duration: '30',
                                units: durationTable(30, parseInt(med.dosis), frecuencyLetters(med.frecuencia))
                            };
                            handlerFormulasNew(formula);
                            return formula
                        })
                        //comp.forEach(form => handlerFormulasNew(form));
                        setPrescriptionPharmacologial(comp);

                        let oldFormulas = dataToTableFormula;
                        let newFormulas = [...oldFormulas, ...comp]
                        const uniqueFormulas = [];

                        const unique = newFormulas.filter(element => {
                            const isDuplicate = uniqueFormulas.find(formu => formu.activePrinciple === element.activePrinciple);

                            if (!isDuplicate) {
                                uniqueFormulas.push(element);
                                return true;
                            }

                            return false;
                        });
                        setDataToTableFormula(unique);
                        resolve(false);
                    } else {
                        console.log(data.contenido);
                        resolve(false);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        })
    }

    const dropFromTable = (indexTable) => {
        console.log("FUNC_INDEX", indexTable);
        let dataTable = dataToTableFormula;
        let newDataTable = dataTable.filter((formu, index) => indexTable !== index);
        console.log("FUNC_newDataTable", newDataTable);
        setDataToTableFormula(newDataTable);
    }


    const dataFormula = {
        tableHeaderData: [
            {
                Header: 'PRINCIPIO ACTIVO',
                accessor: 'activePrinciple',
                disableGlobalFilter: true
            },
            {
                Header: 'CONCENTRACION',
                accessor: 'concentration',
            },
            {
                Header: 'FORMA FARMACEUTICA',
                accessor: 'pharmaceuticalForm',
            },
            {
                Header: 'VIA DE ADMINISTRACION',
                accessor: 'route',
            },
            {
                Header: 'DOSIS',
                accessor: 'dose',
            },
            {
                Header: 'FRECUENCIA',
                accessor: 'frequency',
                Cell: row => (
                    `${row.row.original.frequency === "Otros" ? row.row.original.otherFrequency ?? row.row.original.frequency : row.row.original.frequency }`
                ),

            },
            {
                Header: 'DURACION',
                accessor: 'duration',
            },
            {
                Header: 'UNIDADES',
                accessor: 'units',
                Cell: row => (
                    `${row.row.original?.units != null ? row.row.original.units.toString() : ""}`
                ),
            }
        ],
        tableRowsData: dataToTableFormula
    };

    const LoadTableMedicines = () => {
        return (
            <DataReactTable
                title=""
                reactTableData={dataFormula}
                config={{
                    withPagination: true,
                    withSearchEngine: false,
                    isSortable: false,
                    isEditable: false,
                    watchCustomMenu: false
                }}
                removeFormulaByIndex={removeFormulaByIndex}
                dropFromTable={dropFromTable}
                onUpdateFormula={onUpdateFormula}
                disabledTextFields={isCloseClinicHistory}
                recalculateUnits={recalculateUnits}
                ReactTableActions={ReactTableActionsFormula}
                Callback={() => {
                    var data = formulas;
                    data.pop();
                    setFormulas(data);
                    //removeFormula();
                }}
            />
        )
    }

    const recalculateUnits = (rowIndex, columnId, value) => {
        let dataTable = dataToTableFormula;
        dataTable[rowIndex][columnId] = value;
        let units = durationTable(parseInt(dataTable[rowIndex].duration), parseInt(dataTable[rowIndex].dose), frecuencyLetters(dataTable[rowIndex].frequency));
        dataTable[rowIndex]['units'] = units.toString();
        console.log('dataTable', dataTable);
        let newData = dataTable;
        setDataToTableFormula(newData);
    }

    /*   const addMoreDiagnostics = (diagnostic) => {
          let diagnosticNew = diagnostic;
          this.setState({ loadAddedDiagnostics: true, }, () => {
      
            var addedDiagnostics = this.state.addedDiagnostics;
            console.log(this.state.addedDiagnostics);
            if (!this.props.MedicalOrders.addedDiagnostics.includes(diagnosticNew)) {
              addedDiagnostics.push(diagnosticNew);
              this.props.MedicalOrders.addedDiagnostics.push(diagnosticNew);
            } else {
              alert("Ya se incluyo este diagnostico");
            }
            this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 }, () => {
              //this.props.addDiagnostic(diagnosticNew);        
            });
          })
      
        } */

    return (
        <Fragment>
            <Col md={12} sm={12}>
                <div className={"container-wraper-hc"}>
                    {!MedicalOrders.load ?
                        <Fragment>
                            {/* <Row>
                                <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                                    <div className="title-clinic-history">
                                        <h4>Procedimiento y Servicios</h4>
                                    </div>
                                    <div style={{ margin: '1em 0em', display: 'flex', flexDirection: 'row' }}>
                                        <div>
                                            <h5 className='common-label-section-others'>Procedimientos</h5>
                                            <Button
                                                color="primary"
                                                style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                                                onClick={() => {
                                                    setModalProcedures(true);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faNotesMedical} style={{ color: 'gray' }} />
                                            </Button>
                                        </div>
                                        <div style={{ marginLeft: 15 }} >
                                            <h5 className='common-label-section-others'>Examenes</h5>
                                            <Button
                                                color="primary"
                                                style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                                                onClick={() => {
                                                    setModalLabs(true);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faVial} style={{ color: 'gray' }} />
                                            </Button>
                                        </div>
                                        <div style={{ marginLeft: 15 }} >
                                            <h5 className='common-label-section-others'>Consultas</h5>
                                            <Button
                                                color="primary"
                                                style={{ paddingLeft: 10, margin: 'auto', fontSize: 25 }}
                                                onClick={() => {
                                                    setModalConsult(true);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faStethoscope} style={{ color: 'gray' }} />
                                            </Button>
                                        </div>

                                        <div style={{ marginLeft: 50 }} >
                                            <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar </span>
                                            <Button
                                                color="primary"
                                                style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                                                disabled={isCloseClinicHistory}
                                                onClick={() => {
                                                    setOpenModal(!openModal)
                                                }}
                                            >
                                                <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                            </Button>
                                        </div>

                                    </div>

                                    {modalProcedures ? <ProceduresModal data={proceduresList} openModal={modalProcedures} setOpenModal={setModalProcedures} addDiagnostic={this.addMoreDiagnostics} disabledForm={isCloseClinicHistory} /> : null}
                                    {modalConsult ? <ConsulationModal data={consultList} openModal={modalConsult} setOpenModal={setModalConsult} addDiagnostic={this.addMoreDiagnostics} disabledForm={isCloseClinicHistory} /> : null}
                                    {modalLabs ? <LabsModal data={labList} openModal={modalLabs} setOpenModal={setModalLabs} addDiagnostic={this.addMoreDiagnostics} disabledForm={isCloseClinicHistory} /> : null}
                                    <div>

                                    </div>
                                </div>
                            </Row>
                            <Row>
                                <div className="table-medicine-add">
                                    <table className="table table--bordered" >
                                        <thead className="thead th">
                                            <tr className="react-table thead tr">
                                                <th style={{ maxWidth: 50, columnGap: 5 }}>
                                                    <Header column="CUPS" />
                                                </th>
                                                <th style={{ maxWidth: 400, columnGap: 5 }}>
                                                    <Header column="DESCRIPCIÓN" />
                                                </th>
                                                <th style={{ maxWidth: 200, columnGap: 5 }}>
                                                    <Header column="OBSERVACIÓN" />
                                                </th>
                                                <th style={{ maxWidth: 100, columnGap: 5 }}>
                                                    <Header column="ACCIÓN" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {MedicalOrders.addedDiagnostics.map((diagnostic, index) => {
                                                return <tr key={index}>
                                                    <td>{diagnostic.cupscod}</td>
                                                    <td style={{ maxWidth: 400, padding: '0.5em 1em' }}>{diagnostic.cupsnom}</td>
                                                    <td>
                                                        <div className="form">
                                                            <div className="form__form-group">
                                                                <div className="form__form-group-field" style={{ marginTop: '0.5em' }}>
                                                                    <textarea
                                                                        rows='2'
                                                                        style={{ minHeight: 35 }}
                                                                        name={`observation-${index}`}
                                                                        type="text"
                                                                        value={this.state.observations[index]}
                                                                        disabled={isCloseClinicHistory}
                                                                        onChange={(e) => {
                                                                            var observations = this.state.observations;
                                                                            observations[index] = e.target.value;
                                                                            this.setState({ observations: observations });
                                                                            addObservation(index, e.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ marginLeft: 10 }}>
                                                        <Tooltip title="Eliminar"
                                                            disabled={isCloseClinicHistory}
                                                        >
                                                            <IconButton
                                                                onClick={() => {
                                                                    var data = this.state.addedDiagnostics;
                                                                    data = data.filter((value, indexDiag) => {
                                                                        return indexDiag !== index;
                                                                    });
                                                                    var observations = this.state.observations;
                                                                    observations = observations.filter((value, indexDiag) => {
                                                                        return indexDiag !== index;
                                                                    });
                                                                    console.log(data);
                                                                    console.log(index);
                                                                    this.setState({ addedDiagnostics: data, observations: observations, countDiagnostic: this.state.countDiagnostic - 1 }, () => {
                                                                        removeDiagnostic(index);
                                                                    })
                                                                }}
                                                            >
                                                                <DeleteForeverIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </Row>
                            <Row>
                                <div className="form">
                                    <div className="form__form-group" style={{ marginTop: 10 }}>
                                        <span className='common-label-section-others'>Observaciones Procedimientos y Servicios</span>
                                        <div className="form__form-group-field">
                                            <textarea
                                                name="textarea-observations-exams"
                                                value={MedicalOrders.observationAndProcedure}
                                                disabled={isCloseClinicHistory}
                                                onChange={(e) => { handlerObservationAndProcedureTextMedicalOrder(e.target.value); }}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </Row> */}
                            <Row>
                                <div className="form__form-group" style={{ width: 500, minWidth: 250 }}>
                                    <div className="title-clinic-history">
                                        <h4>Medicamentos</h4>
                                    </div>
                                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} >Buscar Medicamentos</span>
                                    <Tooltip title="Buscar"
                                        disabled={isCloseClinicHistory}
                                    >
                                        <IconButton
                                            color="primary"
                                            disabled={isCloseClinicHistory}
                                            onClick={() => {
                                                setOpenMedicines(!openMedicines)
                                            }}
                                        >
                                            <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </Row>
                            <Row>
                                <div className="table-medicine-add">
                                    <table className="table table--bordered" >
                                        <thead>
                                            <tr>
                                                <td >Principio Activo - Denominación Común Internacional </td>
                                                <td >Concentración </td>
                                                <td >Forma Farmacéutica </td>
                                                <td >Vía de Administración </td>
                                                <td >Dosis </td>
                                                <td >Frecuencia </td>
                                                <td >Duración (Días) </td>
                                                <td > Cantidad </td>
                                                <td > </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td ><TextField
                                                    type="text"
                                                    className="material-form__field"
                                                    style={{ width: 350 }}
                                                    value={principioactivo}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        setPrincipioactivo(event.target.value);
                                                    }}
                                                /> </td>
                                                <td ><TextField
                                                    type="text"
                                                    className="material-form__field"
                                                    style={{ width: 100 }}
                                                    value={cantidad}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        setCantidad(event.target.value);
                                                    }}
                                                />  </td>
                                                <td ><TextField
                                                    type="text"
                                                    className="material-form__field"
                                                    style={{ width: 200 }}
                                                    value={formafarmaceutica}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        setFormafarmaceutica(event.target.value);
                                                    }}
                                                />  </td>
                                                <td ><TextField
                                                    type="text"
                                                    className="material-form__field"
                                                    style={{ width: 150 }}
                                                    value={viaadministracion}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        setViaadministracion(event.target.value);
                                                    }}
                                                /> </td>
                                                <td ><TextField
                                                    required
                                                    type="number"
                                                    className="material-form__field"
                                                    style={{ width: 80 }}
                                                    value={dosis}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        setDosis(event.target.value);
                                                    }}
                                                />  </td>
                                                <td ><TextField
                                                    className="material-form__field"
                                                    style={{ width: 180, }}
                                                    select
                                                    disabled={isCloseClinicHistory}
                                                    value={frequence}
                                                    onChange={(event) => {
                                                        setFrequence(event.target.value);
                                                    }}
                                                >
                                                    {/* <MenuItem className="material-form__option" key={0} value={'Cada 4 horas'}>Cada 4 horas dd</MenuItem>
                                                    <MenuItem className="material-form__option" key={0} value={'Cada 8 horas'}>Cada 8 horas cc</MenuItem> */}
                                                    <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                                                    <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                                                    <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                                                    <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                                                    <MenuItem className="material-form__option" key={4} value={'Una vez a la semana'}>Una vez a la semana</MenuItem>
                                                    <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                                                    <MenuItem className="material-form__option" key={11} value={'Cada 15 dias'}>Cada 15 días</MenuItem>
                                                    <MenuItem className="material-form__option" key={5} value={'Una vez al mes'}>Una vez al mes</MenuItem>
                                                    <MenuItem className="material-form__option" key={6} value={'Una cada dos meses'}>Una cada dos meses</MenuItem>
                                                    <MenuItem className="material-form__option" key={9} value={'Una cada tres meses'}>Una cada tres meses</MenuItem>
                                                    <MenuItem className="material-form__option" key={7} value={'Una cada seis meses'}>Una cada seis meses</MenuItem>
                                                    <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis única</MenuItem>
                                                    <MenuItem className="material-form__option" key={10} value={'Según necesidad'}>Según necesidad</MenuItem>
                                                    <MenuItem className="material-form__option" key={12} value={'Otros'}>Otros</MenuItem>
                                                </TextField> </td>
                                                <td ><TextField
                                                    required
                                                    type="number"
                                                    className="material-form__field"
                                                    style={{ width: 100 }}
                                                    value={duration}
                                                    disabled={isCloseClinicHistory}
                                                    onChange={(event) => {
                                                        handlerDuration(event.target.value);
                                                    }}
                                                />  </td>
                                                <td > <TextField
                                                    required
                                                    type="number"
                                                    className="material-form__field"
                                                    style={{ width: 80 }}
                                                    disabled={isCloseClinicHistory}
                                                    value={cantidadMedicamentes}
                                                    onChange={(event) => {
                                                        setCantidadMedicamentes(event.target.value);
                                                    }}
                                                /></td>
                                                <td >
                                                    {onEdit ?
                                                        <Tooltip title="Actualizar"
                                                            disabled={isCloseClinicHistory}
                                                        >
                                                            <IconButton
                                                                color="primary" onClick={() => {
                                                                    onUpdateFormulaFromTable();
                                                                }}>
                                                                <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        :
                                                        <Tooltip title="Agregar"
                                                            disabled={isCloseClinicHistory}
                                                        >
                                                            <IconButton
                                                                color="primary" onClick={() => {
                                                                    createFormula();
                                                                }}>
                                                                <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                </td>
                                            </tr>
                                            {frequence === 'Otros' ? 
                                                <td align="right" colSpan={6}> 
                                                    <TextField
                                                        required
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 200}}
                                                        placeholder="Ingresa la frecuencia"
                                                        value={otherFrequency}
                                                        onChange={(event) => {
                                                            setOtherFrequency(event.target.value);
                                                        }}
                                                    />
                                                </td>
                                             : null}
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </Row>
                            <Row>
                                <div className="table-medicine-add">
                                    <LoadTableMedicines />
                                </div>
                            </Row>
                            <Row>
                                <div className="form">
                                    <div className="form__form-group" style={{ marginTop: 10 }}>
                                        <span className="className='common-label-section-others">Observaciones Medicamentos</span>
                                        <div className="form__form-group-field">
                                            <textarea
                                                name="textarea-medications-observations"
                                                value={MedicalOrders.medicalObservation}
                                                disabled={isCloseClinicHistory}
                                                onChange={(e) => {
                                                    handlerMedicalObservationTextMedicalOrder(e.target.value)
                                                }}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <SearchModalMedicines
                                openModalMedicine={openMedicines}
                                closeModalMedicine={() => {
                                    setOpenMedicines(false);
                                }}
                                Callback={(med) => {
                                    setMedicine(med);
                                    setOpenMedicines(false);
                                    setPrincipioactivo(med.principioactivo);
                                    setViaadministracion(med.viaadministracion);
                                    setFormafarmaceutica(med.formafarmaceutica);
                                    setCantidad(med.cantidad + med.unidadmedida);
                                }}
                            />
                        </Fragment>
                        : null}
                </div>
            </Col>
        </Fragment>
    )
}
export default MedicalOrdersFunctionalCom